import useWindowSize from '../hooks/useWindowSize';

export const useIsMobile = () => {
    const { width } = useWindowSize(768);

    return width < 768;
};
